import React from 'react'
import classes from './Buttons.module.css'
import PropTypes from 'prop-types';

const ButtonRoundedEdges = ({ onClick, bgColor, color, children }) => {
    return (<button className={`${classes.Btn} ${classes.BtnRoundedEdges}`}
        onClick={(e)=>{onClick();e.stopPropagation()}}
        style={{ background: bgColor, color: color }}>{children}
    </button>)
}

ButtonRoundedEdges.propTypes = {
    bgColor: PropTypes.string,
    onClick: PropTypes.func,
    color:PropTypes.string
}



export default ButtonRoundedEdges;